import { useSelector } from 'react-redux';
import ContactAdaAgent from '~/components/support/contact-ada-agent.js';

const ContactSupportAgent = ({
	chatTags = [],
	metaFields = {},
	className,
	callbackFunction,
	buttonText,
	buttonIcon
}) => {
	const support = useSelector(state => state.support);

	if (support.ada) {
		return (
			<ContactAdaAgent
				proactiveChatReason={chatTags}
				metaFields={metaFields}
				className={className}
				buttonText={buttonText}
				callbackFunction={callbackFunction}
				buttonIcon={buttonIcon}
			/>
		);
	}

	return null;
};

export default ContactSupportAgent;
